import * as React from 'react';

import { IAddressSuggestProps } from '../../types';
import {
  ADDRESS_SUGGEST_MIN_SEARCH_LENGTH,
  ADDRESS_SUGGEST_NOT_FOUND_TEXT,
  ADDRESS_SUGGEST_PLACEHOLDER,
} from '../../const';
import { SuggestFieldContainer } from '../../../SuggestFieldContainer';

export const AddressSuggest: React.FC<IAddressSuggestProps> = props => {
  return (
    <SuggestFieldContainer
      minSearchLength={ADDRESS_SUGGEST_MIN_SEARCH_LENGTH}
      placeholder={ADDRESS_SUGGEST_PLACEHOLDER}
      notFoundText={ADDRESS_SUGGEST_NOT_FOUND_TEXT}
      {...props}
    />
  );
};
